import { opportunityPermissions, permissions, adminPermissions } from '@/auth';
import {
  HistoryTab,
} from '@/components/geek-profile';
import { router } from '@/main';
import {
  AccessDeniedView,
  BasicAdminView,
  BasicDashboardView,
  BasicGCoinsView,
  BasicGeekProfileView,
  BasicLeaderboardView,
  BasicRulesView,
  ErrorView,
  ExchangeGCoinsTab,
  FeedbackView,
  GeeksBalanceTab,
  BasicGCoinsManagementView,
  GCoinsHistoryTab,
  GeeksManagementView,
  OpportunityCancelationView,
  OpportunityDetailsView,
  OpportunityDraftDetailsView,
  OpportunityDraftEditView,
  OpportunityEditView,
  OpportunityFinalizationView,
  OpportunityNewView,
  OpportunityPermissionsView,
  OpportunityRootView,
  OpportunityView,
  RewardGeekView,
  SeasonsManagementView,
  NewsManagementView,
  NewsEditView,
} from '@/views';
import { flatPermissions } from '@/shared';
import { RootStore } from '@/store';
import { RouteConfig } from 'vue-router';

export const ROUTES_GLOBAL: RouteConfig[] = [
  {
    path: '/',
    redirect: 'home',
  },
  {
    path: '/home',
    name: 'home',
    component: BasicDashboardView,
    meta: { requiredPermissions: permissions.home },
  },
  {
    path: '/opportunities',
    component: OpportunityRootView,
    meta: { requiredPermissions: permissions.opportunity },
    children: [
      {
        path: '',
        name: 'opportunity',
        component: OpportunityView,
      },
      {
        path: 'new',
        name: 'opportunity-new',
        component: OpportunityNewView,
        meta: { requiredPermissions: opportunityPermissions.addNewOpportunity },
      },
      {
        path: 'permissions',
        name: 'opportunity-permissions',
        component: OpportunityPermissionsView,
        meta: { requiredPermissions: opportunityPermissions.grantRoles },
      },
      {
        path: ':id',
        name: 'opportunity-details',
        component: OpportunityDetailsView,
        props: true,
      },
      {
        path: ':id/cancelation',
        name: 'opportunity-cancelation',
        component: OpportunityCancelationView,
      },
      {
        path: ':id/finalization',
        name: 'opportunity-finalization',
        component: OpportunityFinalizationView,
      },
      {
        path: ':id/edit',
        name: 'opportunity-edit',
        component: OpportunityEditView,
        meta: { requiredPermissions: opportunityPermissions.addNewOpportunity },
      },
      {
        path: 'drafts/:id',
        name: 'opportunity-draft-details',
        component: OpportunityDraftDetailsView,
        props: true,
      },
      {
        path: 'drafts/:id/edit',
        name: 'opportunity-draft-edit',
        component: OpportunityDraftEditView,
        meta: { requiredPermissions: opportunityPermissions.addNewOpportunity },
      },
    ],
  },
  {
    path: '/rules',
    name: 'rules',
    component: BasicRulesView,
    meta: { requiredPermissions: permissions.rules },
  },
  {
    path: '/reward-geek',
    name: 'reward-geek',
    component: RewardGeekView,
    meta: { requiredPermissions: permissions.rewardGeek },
  },
  {
    path: '/geek-profile',
    name: 'your-geek-profile',
    beforeEnter: () => {
      router.push({name: 'geek-profile', params: {geekId: RootStore.state.geek.current.id}});
    },
  },
  {
    path: '/geek-profile/:geekId',
    component: BasicGeekProfileView,
    meta: { requiredPermissions: permissions.geekProfile },
    children: [
      {
        path: '',
        name: 'geek-profile',
        component: HistoryTab,
        redirect: { name: 'geek-history' },
      },
      {
        path: 'history',
        name: 'geek-history',
        component: HistoryTab,
        props: {
          showFilters: false,
        },
      },
    ],
  },
  {
    path: '/leaderboard',
    name: 'leaderboard',
    meta: { requiredPermissions: permissions.leaderboard },
    component: BasicLeaderboardView,
  },
  {
    path: '/admin-panel',
    component: BasicAdminView,
    meta: { requiredOneOfPermissions: flatPermissions(adminPermissions) },
    children: [
      {
        path: '',
        name: 'admin-panel',
      },
      {
        path: 'gcoins',
        component: BasicGCoinsManagementView,
        meta: { requiredPermissions: adminPermissions.gCoins },
        children: [
          {
            path: '',
            name: 'admin-gcoins',
            component: HistoryTab,
            redirect: { name: 'admin-gcoins-history' },
          },
          {
            path: 'history',
            name: 'admin-gcoins-history',
            component: GCoinsHistoryTab,
          },
          {
            path: 'balance',
            name: 'admin-gcoins-balance',
            component: GeeksBalanceTab,
          },
          {
            path: 'add',
            name: 'admin-gcoins-add',
            component: ExchangeGCoinsTab,
          },
          {
            path: 'exchange',
            name: 'admin-gcoins-exchange',
            component: ExchangeGCoinsTab,
          },
        ],
      },
      {
        path: 'geeks',
        name: 'admin-geeks',
        component: GeeksManagementView,
        meta: { requiredPermissions: adminPermissions.geeks },
      },
      {
        path: 'seasons',
        name: 'admin-seasons',
        component: SeasonsManagementView,
        meta: { requiredPermissions: adminPermissions.seasons },
      },
      {
        path: 'news',
        name: 'admin-news',
        component: NewsManagementView,
        meta: { requiredPermissions: adminPermissions.news },
      },
      {
        path: 'news/edit',
        name: 'news-edit',
        component: NewsEditView,
        meta: { requiredPermissions: adminPermissions.news },
      },
    ],
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: FeedbackView,
    meta: { requiredPermissions: permissions.feedback },
  },
  {
    path: '/gcoins',
    name: 'gcoins',
    component: BasicGCoinsView,
    meta: { requiredPermissions: permissions.gCoins },
  },
  {
    path: '/error',
    name: 'error-page',
    component: ErrorView,
  },
  {
    path: '/access-denied',
    name: 'access-denied-page',
    component: AccessDeniedView,
  },
  {
    path: '*',
    redirect: { name: 'error-page', params: { errorMessageKey: 'not-found' } },
  },
];
